// @ts-nocheck

import { optionsRelated } from '@apgnext/project/legacy/js/overrides/organisms/productWidgets/utils/options';
import React, { useEffect, useMemo } from 'react';

import clsx from 'clsx';
import { getStores } from '@srcDS/js/hooks/useStoreLocator';
import Breadcrumbs from '@srcDS/js/components/molecules/breadcrumbs/Breadcrumbs';
import DeliveryDetails from '@srcDS/js/components/molecules/deliveryDetails';
import StickyAddTo from '@srcDS/js/components/molecules/stickyAddTo';
import FindStoreDrawerV2 from '@srcDS/js/components/organisms/findStoreDrawer_v2';
import FindStoreDrawer from '@srcDS/js/components/organisms/findStoreDrawer';
import ProductActions from '@srcDS/js/components/organisms/productActions';

import ProductInfo from '@srcDS/js/components/organisms/productInfo';
import RecentlyViewedProduct from '@srcDS/js/components/organisms/productWidgets/RecentlyViewedProduct';
import RelatedProducts from '@srcDS/js/components/organisms/productWidgets/RelatedProducts';
import ProductFeatures from '@srcDS/js/components/organisms/productFeatures';
import ReviewSummary from '@srcDS/js/components/molecules/reviewSummary/ReviewSummary';
import styles from './ProductPage.module.scss';
import AskQuestion from '@srcDS/js/components/molecules/askQuestion';
import InstagramProductSlider from '@srcDS/js/components/molecules/instagramProductSlider';
import QuoteCallout from '@srcDS/js/components/molecules/quoteCallout/QuoteCallout';
import SocialShare from '@srcDS/js/components/organisms/socialShare/SocialShare';
import ProductGallery from '@srcDS/js/components/organisms/productGallery';
import TrustSignals from '@srcDS/js/components/organisms/trustSignals';
import CompleteTheOutfit from '@srcDS/js/components/organisms/productWidgets/CompleteTheOutfit';

import { useProductSelection } from '@apgnext/frontend/legacy/js/components/templates/product/hooks/useProductSelection';
import { useProductVariant } from '@apgnext/frontend/legacy/js/components/templates/product/hooks/useProductVariant';
import { useProductDetails } from '@apgnext/frontend/legacy/js/components/templates/product/hooks/useProductDetails';
import { useProductImages } from '@apgnext/frontend/legacy/js/components/templates/product/hooks/useProductImages';

const ProductPage = ({
  data,
  product,
  context,
  handleAddToCart,
  handleChangeVariant,
  vipEnabled = true,
  onOpenChat,
  breadcrumbs,
  isSSR,
  nostoProductClick,
  hasAvailableSizeGuide,
}) => {
  const { productId } = product;

  const {
    findStoreTypeStorage,
    findStoreType,
    setFindStoreType,
    selectedStore,
    selectedStoreState,
    storeList,
    setStoreList,
    statusMenu,
    setStatusMenu,
    activeTab,
    setActiveTab,
    addToRef,
    dispatch,
    isMobile,
    goToTop,
    currentSiteRegion,
    state,
    shouldHideClickCollect,
    register,
    getValues,
    setValue,
    selectedQty,
    setShowDialog,
    handleSetSelectedStore,
  } = useProductSelection();

  const {
    variants,
    selectedVariant,
    setSelectedVariant,
    activeOptions,
    setActiveOption,
    isSelectingSize,
    firstAvailableVariant,
    productName,
    productDescription,
    attributes,
    variantList,
    features,
    styleId,
    displayAlphaSize,
    whyWeLoveItTitle,
    finalSale,
    finalSaleMessage,
    completeTheOutfitProducts,
    getVariantFromSku,
    hasQuoteText,
  } = useProductVariant({ product, setValue, handleChangeVariant, sizeDefaultLabel: 'Select a Size' });

  const { dataInfo, currentSelectedStore } = useProductDetails({
    attributes,
    productDescription,
    data,
    currentSiteRegion,
    selectedVariant,
    selectedStore,
    storeList,
    dispatch,
  });

  const { productImages, sortedImages } = useProductImages({ selectedVariant, attributes, isContainThumbUrl: true });

  const FindStoreDrawerComponent = findStoreType === 'newFindAStore' ? FindStoreDrawerV2 : FindStoreDrawer;

  const breadcrumbsMemo = useMemo(() => {
    return (
      <Breadcrumbs
        className={styles.crumbs}
        crumbs={[
          {
            id: 'bc-home',
            name: 'Home',
            reference: {
              target: '/',
              type: 'link',
            },
          },
          ...breadcrumbs,
        ]}
      />
    );
  }, [breadcrumbs]);

  const galleryComponent = useMemo(() => {
    return (
      <div className={styles.gallery}>
        <ProductGallery
          isSSR={isSSR}
          productName={productName}
          isDemo={false}
          images={productImages}
          productOverlayUrl={selectedVariant?.attributes?.productoverlayurl}
          alt={productName + (selectedVariant.attributes.colour ? ` in ${selectedVariant.attributes.colour}` : '')}
          text={attributes && attributes.productquote}
          textAuthor={attributes && attributes.productquoteauthor}
          isSelectingSize={isSelectingSize}
          variant={selectedVariant}
        />
      </div>
    );
  }, [variants, selectedVariant, productImages, isSelectingSize, isSSR]);

  useEffect(() => {
    setValue('qty', 1);
  }, [selectedVariant]);

  useEffect(() => {
    getVariantFromSku();
    setFindStoreType(findStoreTypeStorage || window?.localStorage?.getItem('findStoreType'));
  }, []);

  useEffect(() => {
    if (activeOptions !== null) {
      getStores({
        setStoreList,
        skus: [selectedVariant.sku],
        coordinates: {},
      });
    }
  }, [selectedVariant, activeOptions]);

  useEffect(() => {
    if (product?.variants?.length && !getVariantFromSku()) {
      setSelectedVariant(firstAvailableVariant);
    }
    goToTop();
  }, [product]);

  return (
    <>
      <StickyAddTo
        productName={productName}
        productId={productId}
        register={register}
        getValues={getValues}
        actionButtonRef={addToRef}
        colour={selectedVariant?.attributes?.colour}
        variant={selectedVariant}
        firstAvailableVariant={firstAvailableVariant}
        image={sortedImages && sortedImages.length && sortedImages?.[0]?.url}
        variants={variantList}
        selectVariant={setSelectedVariant}
        setValue={setValue}
        onOpenChat={onOpenChat}
        onAddToCart={handleAddToCart}
        selectedQty={selectedQty}
        onChangeVariant={handleChangeVariant}
        setActiveOption={setActiveOption}
        title={productName}
        isLoggedIn={context.session.loggedIn}
        isSelectingSize={isSelectingSize}
        displayAlphaSize={displayAlphaSize}
      />
      <div>{isMobile && breadcrumbs ? breadcrumbsMemo : null}</div>
      <div className={styles.productTop} data-id={productId}>
        {galleryComponent}
        <div className={`${styles.productInfo} ${!hasQuoteText && styles.additionalProductTop}`}>
          <div>{!isMobile && breadcrumbs ? breadcrumbsMemo : null}</div>
          <ProductActions
            data={data}
            setValue={setValue}
            register={register}
            vipEnabled={vipEnabled}
            hasAvailableSizeGuide={hasAvailableSizeGuide}
            finalSale={finalSale === 'true' || finalSale === true}
            finalSaleMessage={finalSaleMessage}
            isLoggedIn={context.session.loggedIn}
            isSelectingSize={isSelectingSize}
            selectVariant={setSelectedVariant}
            variant={selectedVariant}
            firstAvailableVariant={firstAvailableVariant}
            selectedQty={selectedQty}
            variants={variantList}
            title={productName}
            addToRef={addToRef}
            onAddToCart={handleAddToCart}
            onChangeVariant={handleChangeVariant}
            statusMenu={statusMenu}
            setStatusMenu={setStatusMenu}
            selectedStore={selectedStoreState}
            activeOptions={activeOptions}
            setActiveOption={setActiveOption}
            parentProduct={product}
            currentSelectedStore={currentSelectedStore}
            findStoreType={findStoreType}
            storeList={storeList}
            displayAlphaSize={displayAlphaSize}
            productId={styleId?.value}
          />
          {data?.signals?.length > 0 && <TrustSignals signals={data.signals} />}
          {findStoreType !== 'newFindAStore' && (
            <DeliveryDetails
              selectedStore={selectedStoreState}
              selectedVariant={selectedVariant}
              currentSiteRegion={currentSiteRegion}
              dispatch="Monday"
              storeList={storeList}
              className={styles.delivery}
              setStatusMenu={setStatusMenu}
              shouldHideClickCollect={shouldHideClickCollect}
              handleOpenStoreLocator={(e) => {
                dispatch({ type: 'open-storelocator' });
                e.stopPropagation();
                e.preventDefault();
              }}
            />
          )}
          <ProductInfo data={dataInfo} className={styles.details} />
          <SocialShare product={product} />
          {hasQuoteText ? (
            <div className={styles.quoteCallout}>
              <QuoteCallout
                alignQuote="center"
                weightQuote="light"
                borders={true}
                text={attributes && attributes.productquote}
                author={attributes && attributes.productquoteauthor}
                sizeAuthor="xs"
                weightAuthor="bold"
              />
            </div>
          ) : null}
        </div>
      </div>
      <div className={styles.productBottom}>
        {completeTheOutfitProducts?.length ? (
            <CompleteTheOutfit
              label={data.completeOutfitLabel}
              title={data.completeOutfitTitle}
              products={completeTheOutfitProducts}
              smOffsets={20}
              {...optionsRelated}
            />
        ) : null}
        <div className={styles.productFeaturesWrapper}>
          {features?.length > 1 && (
            <div className={styles.productFeatures}>
              <ProductFeatures title={whyWeLoveItTitle} items={features} />
            </div>
          )}
          <div />
        </div>

        <div className={styles.related}>
          <RelatedProducts
            productId={productId}
            nostoProductClick={nostoProductClick}
            relatedTitle={data.relatedSubtitle}
            relatedPlacement={data.relatedPlacement}
          />
        </div>
        <InstagramProductSlider
          productID={styleId?.value}
          title={data.instagramTitle}
          titleLink={data.instagramLinkTitle}
          link={data.instagramLink}
        />
        <div className={styles.tabs}>
          <span onClick={() => setActiveTab('reviews')} className={clsx({ [styles.active]: activeTab === 'reviews' })}>
            reviews
          </span>
          <span
            onClick={() => setActiveTab('questions')}
            className={clsx({ [styles.active]: activeTab === 'questions' })}
          >
            questions
          </span>
        </div>

        <div
          className={clsx(styles.tabText, {
            [styles.activeTabText]: activeTab === 'questions',
          })}
        >
          <AskQuestion productId={styleId?.value} title={productName} />
        </div>

        <div
          className={clsx(styles.tabText, {
            [styles.activeTabText]: activeTab === 'reviews',
          })}
        >
          <ReviewSummary productId={styleId?.value} title={productName} description={productDescription} />
        </div>

        <div className={styles.upsell}>
          <RecentlyViewedProduct
            productId={productId}
            nostoProductClick={nostoProductClick}
            recentlyViewedTitle={data.recentlyViewedSubtitle}
            recentlyViewedPlacement={data.recentlyViewedPlacement}
          />
        </div>
      </div>
      <FindStoreDrawerComponent
        register={register}
        activeOptions={activeOptions}
        handleSetSelectedStore={handleSetSelectedStore}
        selectedStore={selectedStoreState}
        setShowDrawer={setShowDialog}
        onChangeVariant={handleChangeVariant}
        setActiveOption={setActiveOption}
        selectVariant={setSelectedVariant}
        isSelectingSize={isSelectingSize}
        showDrawer={state.storeLocatorOpen}
        sizeOptions={variantList}
        storeList={storeList}
        selectedSize={selectedVariant}
        setValue={setValue}
        currentSku={selectedVariant ? selectedVariant.sku : variants.map((x) => x.sku)}
        shouldHideClickCollect={shouldHideClickCollect}
      />
    </>
  );
};

export default ProductPage;
